import type { FaireProductEntity } from "../../entity_types/product";

export const p_a9y9yrsm4u: FaireProductEntity = {
  token: "p_a9y9yrsm4u",
  type: "product",
  name: "Blue Ribbon Little Stickies",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f46f7f534814ef74c93acfaaf1bb8f19ac989e6a0354106fb51554bbdf2c6b02.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ba5377b32a2b5cfbd3d28ccf9e7dc6a0048f677c0ffe299bb7736057fe4929d2.jpeg",
    "https://cdn.faire.com/fastly/01d7a27d89ce93bdfc778dd6f04c42859cd2c3f8605fd915ef80b9f33eb5b997.jpeg",
  ],
  priceDollars: 5,
  description:
    "Because sometimes you need a little adhesive! Sweet watercolor illustrations bring joy to everyday tasks - perfect for your desk, home, bathroom mirrors, foreheads. The best part? They’re made in partnership with 3M, which means you get that classic Post-it® Notes stickiness that actually sticks!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:25.200Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
